(() => {
  const escapeHtml = (value = '') => String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const initVibePin = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const header = root.querySelector('[data-site-header]');
    const menuButton = root.querySelector('[data-menu-button]');
    const navigation = root.querySelector('[data-navigation]');
    const drawer = root.querySelector('[data-cart-drawer]');
    const backdrop = root.querySelector('[data-cart-backdrop]');
    const closeButton = root.querySelector('[data-cart-close]');
    const cartItems = root.querySelector('[data-cart-items]');
    const cartSubtotal = root.querySelector('[data-cart-subtotal]');
    const cartTotal = root.querySelector('[data-cart-total]');
    const cartProgressCopy = root.querySelector('[data-cart-progress-copy]');
    const cartProgressBar = root.querySelector('[data-cart-progress-bar]');
    const cartUpsell = root.querySelector('[data-cart-upsell]');
    const cartUpgradeButton = root.querySelector('[data-cart-upgrade]');
    const cartError = root.querySelector('[data-cart-error]');
    const checkoutButton = root.querySelector('[data-checkout]');
    const basePath = root.dataset.shopRoot || '/';
    const soloVariantId = Number(root.dataset.soloVariantId || 0);
    const duoVariantId = Number(root.dataset.duoVariantId || 0);
    const trioVariantId = Number(root.dataset.trioVariantId || 0);
    const duoAvailable = root.dataset.duoAvailable === 'true';
    const trioAvailable = root.dataset.trioAvailable === 'true';
    const duoSavings = root.dataset.duoSavings || '';
    const trioSavings = root.dataset.trioSavings || '';
    let returnFocus = null;

    const initCoverflow = () => {
      const viewport = root.querySelector('[data-coverflow-viewport]');
      const stage = root.querySelector('[data-coverflow-stage]');
      const dotsRoot = root.querySelector('[data-coverflow-dots]');
      const previousButton = root.querySelector('[data-coverflow-prev]');
      const nextButton = root.querySelector('[data-coverflow-next]');
      const slides = Array.from(root.querySelectorAll('[data-coverflow-slide]'));
      if (!viewport || !stage || !dotsRoot || slides.length < 2 || viewport.dataset.initialized === 'true') return;
      viewport.dataset.initialized = 'true';

      let activeIndex = 0;
      let pointerId = null;
      let startX = 0;
      let currentX = 0;
      let previousX = 0;
      let previousTime = 0;
      let velocity = 0;
      let moved = false;
      let pressedSlide = null;

      const normalize = (value) => (value + slides.length) % slides.length;
      const relativeIndex = (index) => {
        let distance = index - activeIndex;
        const midpoint = slides.length / 2;
        if (distance > midpoint) distance -= slides.length;
        if (distance < -midpoint) distance += slides.length;
        return distance;
      };

      const render = () => {
        const mobile = window.matchMedia('(max-width: 760px)').matches;
        slides.forEach((slide, index) => {
          const distance = relativeIndex(index);
          const absolute = Math.abs(distance);
          const direction = Math.sign(distance);
          const position = absolute === 0 ? 0 : direction * (absolute === 1 ? (mobile ? 64 : 54) : (mobile ? 112 : 94));
          const scale = absolute === 0 ? (mobile ? 1 : 1.045) : absolute === 1 ? (mobile ? .84 : .89) : (mobile ? .7 : .75);
          const opacity = absolute === 0 ? 1 : absolute === 1 ? .76 : .28;
          const brightness = absolute === 0 ? 1 : absolute === 1 ? .76 : .58;
          const saturation = absolute === 0 ? 1 : absolute === 1 ? .86 : .68;

          slide.style.setProperty('--x', `${position}%`);
          slide.style.setProperty('--y', `${absolute * (mobile ? 14 : 17)}px`);
          slide.style.setProperty('--rotate', `${distance * (mobile ? -3 : -5)}deg`);
          slide.style.setProperty('--scale', scale);
          slide.style.setProperty('--opacity', opacity);
          slide.style.setProperty('--brightness', brightness);
          slide.style.setProperty('--saturation', saturation);
          slide.style.setProperty('--stack', String(10 - absolute));
          slide.style.setProperty('--copy-opacity', absolute === 0 ? '1' : absolute === 1 ? '.14' : '0');
          slide.style.setProperty('--copy-y', absolute === 0 ? '0px' : '9px');
          slide.style.pointerEvents = absolute <= 1 ? 'auto' : 'none';
          slide.classList.toggle('is-active', absolute === 0);
          slide.setAttribute('aria-hidden', absolute === 0 ? 'false' : 'true');
        });

        dotsRoot.querySelectorAll('button').forEach((dot, index) => {
          const selected = index === activeIndex;
          dot.classList.toggle('is-active', selected);
          dot.setAttribute('aria-current', selected ? 'true' : 'false');
        });
      };

      const goTo = (index) => {
        activeIndex = normalize(index);
        viewport.style.setProperty('--drag-x', '0px');
        render();
      };

      slides.forEach((slide, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', `Pokaż: ${slide.querySelector('h3')?.textContent || `zdjęcie ${index + 1}`}`);
        dot.addEventListener('click', () => goTo(index));
        dotsRoot.appendChild(dot);
        slide.addEventListener('dragstart', (event) => event.preventDefault());
      });

      previousButton?.addEventListener('click', () => goTo(activeIndex - 1));
      nextButton?.addEventListener('click', () => goTo(activeIndex + 1));

      viewport.addEventListener('pointerdown', (event) => {
        if (event.button !== 0 || event.target.closest('button')) return;
        pointerId = event.pointerId;
        startX = event.clientX;
        currentX = event.clientX;
        previousX = event.clientX;
        previousTime = performance.now();
        velocity = 0;
        moved = false;
        pressedSlide = event.target.closest('[data-coverflow-slide]');
        viewport.classList.add('is-dragging');
        viewport.setPointerCapture(pointerId);
      });

      viewport.addEventListener('pointermove', (event) => {
        if (pointerId !== event.pointerId) return;
        const now = performance.now();
        currentX = event.clientX;
        const delta = currentX - startX;
        const elapsed = Math.max(1, now - previousTime);
        velocity = (currentX - previousX) / elapsed;
        previousX = currentX;
        previousTime = now;
        moved = moved || Math.abs(delta) > 5;
        viewport.style.setProperty('--drag-x', `${Math.max(-145, Math.min(145, delta))}px`);
      });

      const finishPointer = (event) => {
        if (pointerId !== event.pointerId) return;
        const delta = currentX - startX;
        viewport.classList.remove('is-dragging');
        viewport.style.setProperty('--drag-x', '0px');
        if (viewport.hasPointerCapture(pointerId)) viewport.releasePointerCapture(pointerId);
        pointerId = null;

        if (Math.abs(delta) > 46 || Math.abs(velocity) > .45) {
          goTo(activeIndex + (delta < 0 ? 1 : -1));
        } else if (!moved && pressedSlide) {
          goTo(slides.indexOf(pressedSlide));
        } else {
          render();
        }
        pressedSlide = null;
      };

      viewport.addEventListener('pointerup', finishPointer);
      viewport.addEventListener('pointercancel', finishPointer);
      viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(activeIndex - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(activeIndex + 1);
        }
      });
      window.addEventListener('resize', render, { passive: true });
      render();
    };

    const endpoint = (path) => `${basePath}${path}`.replace(/\/{2,}/g, '/');
    const formatMoney = (cents, currency = 'PLN') => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'pl-PL', {
          style: 'currency',
          currency,
          minimumFractionDigits: 2,
        }).format((Number(cents) || 0) / 100);
      } catch (_error) {
        return `${((Number(cents) || 0) / 100).toFixed(2).replace('.', ',')} zł`;
      }
    };

    const setError = (message = '') => {
      if (!cartError) return;
      cartError.textContent = message;
      cartError.hidden = !message;
    };

    const syncScrollLock = () => {
      const menuOpen = navigation?.classList.contains('nav--open');
      const cartOpen = drawer?.classList.contains('cart--open');
      document.body.style.overflow = menuOpen || cartOpen ? 'hidden' : '';
    };

    const openCart = () => {
      if (!drawer || !backdrop) return;
      returnFocus = document.activeElement;
      drawer.classList.add('cart--open');
      backdrop.classList.add('cart-backdrop--open');
      drawer.setAttribute('aria-hidden', 'false');
      syncScrollLock();
      window.setTimeout(() => closeButton?.focus(), 80);
    };

    const closeCart = () => {
      if (!drawer || !backdrop) return;
      drawer.classList.remove('cart--open');
      backdrop.classList.remove('cart-backdrop--open');
      drawer.setAttribute('aria-hidden', 'true');
      syncScrollLock();
      if (returnFocus instanceof HTMLElement) returnFocus.focus();
    };

    const renderCart = (cart) => {
      const hasDuo = cart.items.some((item) => Number(item.variant_id) === duoVariantId);
      const hasTrio = cart.items.some((item) => Number(item.variant_id) === trioVariantId);
      const soloLine = cart.items.find((item) => Number(item.variant_id) === soloVariantId);
      const physicalItemCount = cart.items.reduce((total, item) => {
        const variantId = Number(item.variant_id);
        const unitsPerLine = variantId === trioVariantId ? 3 : variantId === duoVariantId ? 2 : 1;
        return total + (Number(item.quantity) || 0) * unitsPerLine;
      }, 0);

      root.querySelectorAll('[data-cart-count]').forEach((counter) => {
        counter.textContent = physicalItemCount;
        counter.hidden = physicalItemCount === 0;
      });

      if (cartProgressBar) {
        cartProgressBar.style.width = `${Math.min(100, (physicalItemCount / 3) * 100)}%`;
      }
      if (cartProgressCopy) {
        cartProgressCopy.textContent = hasTrio
          ? `Zestaw Trio gotowy${trioSavings ? ` — oszczędzasz ${trioSavings}` : ''}`
          : hasDuo
          ? `Zestaw Duo gotowy${duoSavings ? ` — oszczędzasz ${duoSavings}` : ''}`
          : physicalItemCount >= 3
            ? `Masz ${physicalItemCount} produkty w koszyku`
            : physicalItemCount === 2
            ? 'Masz 2 produkty w koszyku'
            : physicalItemCount === 1
            ? 'Masz 1 produkt w koszyku'
            : 'Dodaj produkt, aby przejść do płatności';
      }

      if (cartUpsell) {
        const canUpgrade = duoAvailable
          && soloVariantId > 0
          && duoVariantId > 0
          && !hasDuo
          && !hasTrio
          && soloLine?.quantity === 1;
        cartUpsell.hidden = !canUpgrade;
      }

      if (cartItems) {
        if (!cart.items.length) {
          cartItems.innerHTML = '<div class="cart__empty">Koszyk jest pusty.<br>Wybierz wariant Solo, Duo albo Trio.</div>';
        } else {
          cartItems.innerHTML = cart.items.map((item) => {
            const title = item.product_title || item.title || 'VibePin';
            const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
            const isDuo = Number(item.variant_id) === duoVariantId;
            const isTrio = Number(item.variant_id) === trioVariantId;
            const unitCount = isTrio ? item.quantity * 3 : isDuo ? item.quantity * 2 : item.quantity;
            const image = item.image
              ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(title)}" width="176" height="196">`
              : '<span class="cart__fallback-mark">V</span>';
            const actions = isDuo
              ? `<div class="cart__item-actions">
                  <button type="button" data-cart-downgrade aria-label="Usuń jedną sztukę z zestawu Duo">Usuń 1 szt.</button>
                  <button type="button" data-cart-remove data-line-key="${escapeHtml(item.key)}">Usuń zestaw</button>
                </div>`
              : isTrio
              ? `<div class="cart__item-actions">
                  <button type="button" data-cart-remove data-line-key="${escapeHtml(item.key)}">Usuń zestaw</button>
                </div>`
              : `<div class="cart__item-actions">
                  <button type="button" data-cart-remove data-line-key="${escapeHtml(item.key)}">Usuń</button>
                </div>`;
            return `
              <div class="cart__item">
                <div class="cart__thumb">${image}<b class="cart__quantity">${unitCount}×</b></div>
                <div>
                  <strong>${escapeHtml(title)}</strong>
                  <span>${variant ? `${escapeHtml(variant)} · ` : ''}${unitCount} szt.</span>
                  ${actions}
                </div>
                <b>${formatMoney(item.final_line_price ?? item.line_price, cart.currency)}</b>
              </div>`;
          }).join('');
        }
      }

      if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.items_subtotal_price, cart.currency);
      if (cartTotal) cartTotal.textContent = formatMoney(cart.total_price, cart.currency);
      if (checkoutButton) checkoutButton.disabled = cart.item_count === 0;
    };

    const getCart = async () => {
      const response = await fetch(endpoint('cart.js'), {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      if (!response.ok) throw new Error('Nie udało się odczytać koszyka.');
      const cart = await response.json();
      renderCart(cart);
      return cart;
    };

    const addToCart = async (form) => {
      const button = form.querySelector('button[type="submit"]');
      const id = form.querySelector('[name="id"]')?.value;
      const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
      if (!id) {
        setError('Najpierw wybierz produkt VibePin w edytorze motywu.');
        openCart();
        return;
      }

      const originalMarkup = button?.innerHTML;
      if (button) {
        button.disabled = true;
        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
      }
      setError('');

      try {
        const response = await fetch(endpoint('cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: Number(id), quantity }] }),
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || payload.message || 'Nie udało się dodać produktu.');
        await getCart();
        openCart();
      } catch (error) {
        setError(error instanceof Error ? error.message : 'Nie udało się dodać produktu.');
        openCart();
      } finally {
        if (button) {
          button.disabled = false;
          button.classList.remove('is-loading');
          button.removeAttribute('aria-busy');
          if (originalMarkup) button.innerHTML = originalMarkup;
        }
      }
    };

    const removeLine = async (key, button) => {
      button.disabled = true;
      setError('');
      try {
        const response = await fetch(endpoint('cart/change.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: key, quantity: 0 }),
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || 'Nie udało się zmienić koszyka.');
        renderCart(payload);
      } catch (error) {
        setError(error instanceof Error ? error.message : 'Nie udało się zmienić koszyka.');
        button.disabled = false;
      }
    };

    const upgradeToDuo = async (button) => {
      if (!soloVariantId || !duoVariantId || !duoAvailable) return;
      const originalMarkup = button.innerHTML;
      button.disabled = true;
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
      setError('');

      try {
        const response = await fetch(endpoint('cart/update.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: { [soloVariantId]: 0, [duoVariantId]: 1 } }),
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || payload.message || 'Nie udało się zmienić zestawu.');
        renderCart(payload);
      } catch (error) {
        setError(error instanceof Error ? error.message : 'Nie udało się zmienić zestawu.');
      } finally {
        button.disabled = false;
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        button.innerHTML = originalMarkup;
      }
    };

    const downgradeToSolo = async (button) => {
      if (!soloVariantId || !duoVariantId) return;
      const originalMarkup = button.innerHTML;
      button.disabled = true;
      button.textContent = 'Aktualizuję…';
      button.setAttribute('aria-busy', 'true');
      setError('');

      try {
        const response = await fetch(endpoint('cart/update.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: { [duoVariantId]: 0, [soloVariantId]: 1 } }),
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || payload.message || 'Nie udało się usunąć jednej sztuki.');
        renderCart(payload);
      } catch (error) {
        setError(error instanceof Error ? error.message : 'Nie udało się usunąć jednej sztuki.');
        button.disabled = false;
        button.innerHTML = originalMarkup;
        button.removeAttribute('aria-busy');
      }
    };

    root.querySelectorAll('[data-cart-form]').forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        addToCart(form);
      });
    });

    root.querySelectorAll('.faq-item button').forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest('.faq-item');
        const shouldOpen = !item.classList.contains('faq-item--open');
        root.querySelectorAll('.faq-item').forEach((other) => {
          other.classList.remove('faq-item--open');
          other.querySelector('button')?.setAttribute('aria-expanded', 'false');
        });
        if (shouldOpen) {
          item.classList.add('faq-item--open');
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });

    menuButton?.addEventListener('click', () => {
      const open = navigation?.classList.toggle('nav--open');
      menuButton.classList.toggle('menu-button--open', Boolean(open));
      menuButton.setAttribute('aria-expanded', String(Boolean(open)));
      menuButton.setAttribute('aria-label', open ? 'Zamknij menu' : 'Otwórz menu');
      syncScrollLock();
    });

    navigation?.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        navigation.classList.remove('nav--open');
        menuButton?.classList.remove('menu-button--open');
        menuButton?.setAttribute('aria-expanded', 'false');
        syncScrollLock();
      });
    });

    root.addEventListener('click', (event) => {
      const downgradeButton = event.target.closest('[data-cart-downgrade]');
      if (downgradeButton) {
        downgradeToSolo(downgradeButton);
        return;
      }
      const removeButton = event.target.closest('[data-cart-remove]');
      if (removeButton) removeLine(removeButton.dataset.lineKey, removeButton);
    });

    closeButton?.addEventListener('click', closeCart);
    backdrop?.addEventListener('click', closeCart);
    cartUpgradeButton?.addEventListener('click', () => upgradeToDuo(cartUpgradeButton));
    checkoutButton?.addEventListener('click', () => window.location.assign(endpoint('checkout')));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeCart();
        navigation?.classList.remove('nav--open');
        menuButton?.classList.remove('menu-button--open');
        menuButton?.setAttribute('aria-expanded', 'false');
        syncScrollLock();
      }
    });

    const onScroll = () => header?.classList.toggle('site-header--scrolled', window.scrollY > 18);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    initCoverflow();
    getCart().catch(() => setError('Koszyk odświeży się po dodaniu produktu.'));
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-vibepin-root]').forEach(initVibePin);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
